/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Bridge, BridgeInterface } from "../Bridge";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "Burn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "targetChain",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Lock",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "Unlock",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_targetChain",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "_nativeToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_tokenName",
        type: "string",
      },
      {
        internalType: "string",
        name: "_tokenSymbol",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "_tokenDecimals",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeToken",
        type: "address",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "nativeTokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "serviceFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nativeToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6080604052655af3107a40006001556004805461ffff191661727317905534801561002957600080fd5b5061003333610038565b610088565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b612163806100976000396000f3fe60806040523480156200001157600080fd5b5060043610620000cd5760003560e01c80638da5cb5b116200007f5780639dc29fac11620000625780639dc29fac14620001a2578063c86726f614620001b9578063f2fde38b14620001e557600080fd5b80638da5cb5b1462000179578063987d162a146200018b57600080fd5b8063715018a611620000b4578063715018a6146200013f5780638abdf5aa14620001495780638bc39207146200016257600080fd5b806304c2320b14620000d257806330d5d8081462000126575b600080fd5b62000109620000e336600462000c13565b80516020818301810180516002825292820191909301209152546001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b6200013d6200013736600462000c81565b620001fc565b005b6200013d6200046c565b6200015360015481565b6040519081526020016200011d565b6200013d6200017336600462000cc5565b620004d6565b6000546001600160a01b031662000109565b620001096200019c36600462000d0c565b6200072d565b6200013d620001b336600462000dbd565b6200094e565b62000109620001ca36600462000dec565b6003602052600090815260409020546001600160a01b031681565b6200013d620001f636600462000dec565b620009fd565b6001548111620002535760405162461bcd60e51b815260206004820152601160248201527f546f6f20736d616c6c20616d6f756e742100000000000000000000000000000060448201526064015b60405180910390fd5b6000620002608262000ae5565b9050826001600160a01b03166323b872dd33306001600160a01b0316638da5cb5b6040518163ffffffff1660e01b815260040160206040518083038186803b158015620002ac57600080fd5b505afa158015620002c1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620002e7919062000e13565b6001546040517fffffffff0000000000000000000000000000000000000000000000000000000060e086901b1681526001600160a01b0393841660048201529290911660248301526044820152606401602060405180830381600087803b1580156200035257600080fd5b505af115801562000367573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906200038d919062000e33565b506040516323b872dd60e01b8152336004820152306024820152604481018290526001600160a01b038416906323b872dd90606401602060405180830381600087803b158015620003dd57600080fd5b505af1158015620003f2573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062000418919062000e33565b506040805160ff861681526001600160a01b03851660208201529081018290527f0c55699ac3407db860d8ae8a3649121033cd47663adab15e03aea47fdbea7d7f906060015b60405180910390a150505050565b6000546001600160a01b03163314620004c85760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016200024a565b620004d4600062000afd565b565b6001548211620005295760405162461bcd60e51b815260206004820152601160248201527f546f6f20736d616c6c20616d6f756e742100000000000000000000000000000060448201526064016200024a565b6000620005368362000ae5565b9050836001600160a01b031663a9059cbb306001600160a01b0316638da5cb5b6040518163ffffffff1660e01b815260040160206040518083038186803b1580156200058157600080fd5b505afa15801562000596573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620005bc919062000e13565b6001546040517fffffffff0000000000000000000000000000000000000000000000000000000060e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381600087803b1580156200061e57600080fd5b505af115801562000633573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062000659919062000e33565b5060405163a9059cbb60e01b81526001600160a01b0383811660048301526024820183905285169063a9059cbb90604401602060405180830381600087803b158015620006a557600080fd5b505af1158015620006ba573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620006e0919062000e33565b50604080516001600160a01b038087168252602082018690528416918101919091527fae2a2f3f8158e4173d24a3a113140dcec8a721085e8b5c93e5cd7071718e8df2906060016200045e565b60045460405160009182918291620007519160f09190911b908b9060200162000e8a565b604051602081830303815290604052905060006001600160a01b03166002826040516200077f919062000ed5565b908152604051908190036020019020546001600160a01b031614156200088357600454604051600091620007bf9160f09190911b908b9060200162000e8a565b6040516020818303038152906040529050818189604051620007e19062000b5a565b620007ef9392919062000f21565b604051809103906000f0801580156200080c573d6000803e3d6000fd5b50925060008390508060028460405162000827919062000ed5565b9081526040805160209281900383019020805473ffffffffffffffffffffffffffffffffffffffff199081166001600160a01b0395861617909155938316600090815260039092529020805490921690871617905550620008b1565b60028160405162000895919062000ed5565b908152604051908190036020019020546001600160a01b031691505b6040516340c10f1960e01b81526001600160a01b038681166004830152602482018890528316906340c10f1990604401600060405180830381600087803b158015620008fc57600080fd5b505af115801562000911573d6000803e3d6000fd5b5050505060028160405162000927919062000ed5565b908152604051908190036020019020546001600160a01b0316925050509695505050505050565b604051632770a7eb60e21b8152336004820152602481018290526001600160a01b03831690639dc29fac90604401600060405180830381600087803b1580156200099757600080fd5b505af1158015620009ac573d6000803e3d6000fd5b5050604080516001600160a01b038616815260208101859052338183015290517fdbdf9b8e4b75e75b162d151ec8fc7f0561cabab5fcccfa2600be62223e4300c49350908190036060019150a15050565b6000546001600160a01b0316331462000a595760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016200024a565b6001600160a01b03811662000ad75760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f646472657373000000000000000000000000000000000000000000000000000060648201526084016200024a565b62000ae28162000afd565b50565b60006001548262000af7919062000f5e565b92915050565b600080546001600160a01b0383811673ffffffffffffffffffffffffffffffffffffffff19831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6111d28062000f8583390190565b634e487b7160e01b600052604160045260246000fd5b600082601f83011262000b9057600080fd5b813567ffffffffffffffff8082111562000bae5762000bae62000b68565b604051601f8301601f19908116603f0116810190828211818310171562000bd95762000bd962000b68565b8160405283815286602085880101111562000bf357600080fd5b836020870160208301376000602085830101528094505050505092915050565b60006020828403121562000c2657600080fd5b813567ffffffffffffffff81111562000c3e57600080fd5b62000c4c8482850162000b7e565b949350505050565b803560ff8116811462000c6657600080fd5b919050565b6001600160a01b038116811462000ae257600080fd5b60008060006060848603121562000c9757600080fd5b62000ca28462000c54565b9250602084013562000cb48162000c6b565b929592945050506040919091013590565b60008060006060848603121562000cdb57600080fd5b833562000ce88162000c6b565b925060208401359150604084013562000d018162000c6b565b809150509250925092565b60008060008060008060c0878903121562000d2657600080fd5b863567ffffffffffffffff8082111562000d3f57600080fd5b62000d4d8a838b0162000b7e565b9750602089013591508082111562000d6457600080fd5b5062000d7389828a0162000b7e565b95505062000d846040880162000c54565b935060608701359250608087013562000d9d8162000c6b565b915060a087013562000daf8162000c6b565b809150509295509295509295565b6000806040838503121562000dd157600080fd5b823562000dde8162000c6b565b946020939093013593505050565b60006020828403121562000dff57600080fd5b813562000e0c8162000c6b565b9392505050565b60006020828403121562000e2657600080fd5b815162000e0c8162000c6b565b60006020828403121562000e4657600080fd5b8151801515811462000e0c57600080fd5b60005b8381101562000e7457818101518382015260200162000e5a565b8381111562000e84576000848401525b50505050565b7fffff00000000000000000000000000000000000000000000000000000000000083168152815160009062000ec781600285016020870162000e57565b919091016002019392505050565b6000825162000ee981846020870162000e57565b9190910192915050565b6000815180845262000f0d81602086016020860162000e57565b601f01601f19169290920160200192915050565b60608152600062000f36606083018662000ef3565b828103602084015262000f4a818662000ef3565b91505060ff83166040830152949350505050565b60008282101562000f7f57634e487b7160e01b600052601160045260246000fd5b50039056fe60806040523480156200001157600080fd5b50604051620011d2380380620011d2833981016040819052620000349162000270565b8251839083906200004d906003906020850190620000fd565b50805162000063906004906020840190620000fd565b505050620000806200007a620000a760201b60201c565b620000ab565b6005805460ff909216600160a01b0260ff60a01b1990921691909117905550620003329050565b3390565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b8280546200010b90620002f5565b90600052602060002090601f0160209004810192826200012f57600085556200017a565b82601f106200014a57805160ff19168380011785556200017a565b828001600101855582156200017a579182015b828111156200017a5782518255916020019190600101906200015d565b50620001889291506200018c565b5090565b5b808211156200018857600081556001016200018d565b634e487b7160e01b600052604160045260246000fd5b600082601f830112620001cb57600080fd5b81516001600160401b0380821115620001e857620001e8620001a3565b604051601f8301601f19908116603f01168101908282118183101715620002135762000213620001a3565b816040528381526020925086838588010111156200023057600080fd5b600091505b8382101562000254578582018301518183018401529082019062000235565b83821115620002665760008385830101525b9695505050505050565b6000806000606084860312156200028657600080fd5b83516001600160401b03808211156200029e57600080fd5b620002ac87838801620001b9565b94506020860151915080821115620002c357600080fd5b50620002d286828701620001b9565b925050604084015160ff81168114620002ea57600080fd5b809150509250925092565b600181811c908216806200030a57607f821691505b602082108114156200032c57634e487b7160e01b600052602260045260246000fd5b50919050565b610e9080620003426000396000f3fe608060405234801561001057600080fd5b50600436106101005760003560e01c8063715018a611610097578063a457c2d711610066578063a457c2d71461022a578063a9059cbb1461023d578063dd62ed3e14610250578063f2fde38b1461028957600080fd5b8063715018a6146101ec5780638da5cb5b146101f457806395d89b411461020f5780639dc29fac1461021757600080fd5b8063313ce567116100d3578063313ce5671461016b578063395093511461019b57806340c10f19146101ae57806370a08231146101c357600080fd5b806306fdde0314610105578063095ea7b31461012357806318160ddd1461014657806323b872dd14610158575b600080fd5b61010d61029c565b60405161011a9190610cd7565b60405180910390f35b610136610131366004610d48565b61032e565b604051901515815260200161011a565b6002545b60405190815260200161011a565b610136610166366004610d72565b610344565b60055474010000000000000000000000000000000000000000900460ff1660405160ff909116815260200161011a565b6101366101a9366004610d48565b610408565b6101c16101bc366004610d48565b610444565b005b61014a6101d1366004610dae565b6001600160a01b031660009081526020819052604090205490565b6101c16104ac565b6005546040516001600160a01b03909116815260200161011a565b61010d610512565b6101c1610225366004610d48565b610521565b610136610238366004610d48565b610585565b61013661024b366004610d48565b610636565b61014a61025e366004610dd0565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6101c1610297366004610dae565b610643565b6060600380546102ab90610e03565b80601f01602080910402602001604051908101604052809291908181526020018280546102d790610e03565b80156103245780601f106102f957610100808354040283529160200191610324565b820191906000526020600020905b81548152906001019060200180831161030757829003601f168201915b5050505050905090565b600061033b338484610725565b50600192915050565b600061035184848461084a565b6001600160a01b0384166000908152600160209081526040808320338452909152902054828110156103f05760405162461bcd60e51b815260206004820152602860248201527f45524332303a207472616e7366657220616d6f756e742065786365656473206160448201527f6c6c6f77616e636500000000000000000000000000000000000000000000000060648201526084015b60405180910390fd5b6103fd8533858403610725565b506001949350505050565b3360008181526001602090815260408083206001600160a01b0387168452909152812054909161033b91859061043f908690610e54565b610725565b6005546001600160a01b0316331461049e5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016103e7565b6104a88282610a48565b5050565b6005546001600160a01b031633146105065760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016103e7565b6105106000610b27565b565b6060600480546102ab90610e03565b6005546001600160a01b0316331461057b5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016103e7565b6104a88282610b91565b3360009081526001602090815260408083206001600160a01b03861684529091528120548281101561061f5760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f7760448201527f207a65726f00000000000000000000000000000000000000000000000000000060648201526084016103e7565b61062c3385858403610725565b5060019392505050565b600061033b33848461084a565b6005546001600160a01b0316331461069d5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016103e7565b6001600160a01b0381166107195760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f646472657373000000000000000000000000000000000000000000000000000060648201526084016103e7565b61072281610b27565b50565b6001600160a01b0383166107875760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b60648201526084016103e7565b6001600160a01b0382166107e85760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b60648201526084016103e7565b6001600160a01b0383811660008181526001602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92591015b60405180910390a3505050565b6001600160a01b0383166108c65760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f20616460448201527f647265737300000000000000000000000000000000000000000000000000000060648201526084016103e7565b6001600160a01b0382166109285760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b60648201526084016103e7565b6001600160a01b038316600090815260208190526040902054818110156109b75760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e742065786365656473206260448201527f616c616e6365000000000000000000000000000000000000000000000000000060648201526084016103e7565b6001600160a01b038085166000908152602081905260408082208585039055918516815290812080548492906109ee908490610e54565b92505081905550826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef84604051610a3a91815260200190565b60405180910390a350505050565b6001600160a01b038216610a9e5760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f20616464726573730060448201526064016103e7565b8060026000828254610ab09190610e54565b90915550506001600160a01b03821660009081526020819052604081208054839290610add908490610e54565b90915550506040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a35050565b600580546001600160a01b038381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6001600160a01b038216610bf15760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b60648201526084016103e7565b6001600160a01b03821660009081526020819052604090205481811015610c655760405162461bcd60e51b815260206004820152602260248201527f45524332303a206275726e20616d6f756e7420657863656564732062616c616e604482015261636560f01b60648201526084016103e7565b6001600160a01b0383166000908152602081905260408120838303905560028054849290610c94908490610e6c565b90915550506040518281526000906001600160a01b038516907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200161083d565b600060208083528351808285015260005b81811015610d0457858101830151858201604001528201610ce8565b81811115610d16576000604083870101525b50601f01601f1916929092016040019392505050565b80356001600160a01b0381168114610d4357600080fd5b919050565b60008060408385031215610d5b57600080fd5b610d6483610d2c565b946020939093013593505050565b600080600060608486031215610d8757600080fd5b610d9084610d2c565b9250610d9e60208501610d2c565b9150604084013590509250925092565b600060208284031215610dc057600080fd5b610dc982610d2c565b9392505050565b60008060408385031215610de357600080fd5b610dec83610d2c565b9150610dfa60208401610d2c565b90509250929050565b600181811c90821680610e1757607f821691505b60208210811415610e3857634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b60008219821115610e6757610e67610e3e565b500190565b600082821015610e7e57610e7e610e3e565b50039056fea164736f6c6343000809000aa164736f6c6343000809000a";

export class Bridge__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Bridge> {
    return super.deploy(overrides || {}) as Promise<Bridge>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Bridge {
    return super.attach(address) as Bridge;
  }
  connect(signer: Signer): Bridge__factory {
    return super.connect(signer) as Bridge__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BridgeInterface {
    return new utils.Interface(_abi) as BridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Bridge {
    return new Contract(address, _abi, signerOrProvider) as Bridge;
  }
}
